import './addnotification.scss';
import React, { useState } from 'react';
import BusyCounterLoadingIndicator from '../../../sharedmodules/components/busyCounter/busy-counter-loading-indicator';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { isValidNofication } from '../services/notifications-helper';

const AddNotification = ({
    item, busyCounter, isEdit, editNotificationItem, addNotification,
}) => {

    const { shortText, title, url } = item;
    const [notification, setNotification] = useState({ shortText, title, url });
    const [fieldTouch, setFieldTouched] = useState({
        shortText: false, language: false, title: false, url: false,
    });

    const handleInputChange = (e) => {

        e.preventDefault();
        setNotification({
            ...notification,
            [e.target.name]: e.target.value,
        });
        setFieldTouched({
            ...fieldTouch,
            [e.target.name]: true,
        });

    };

    const getValidationation = (fieldTitle, notificationTitle) => (fieldTitle && !notificationTitle) ? 'field-error' : '';

    return (
        <section className="add-notification-header">
            <BusyCounterLoadingIndicator busyCounter={busyCounter} />
            <div className="add-notification-label required">
                <label><FormattedMessage id="TITLE" /></label>
                <input type="text" maxLength={255} className={getValidationation(fieldTouch.title, notification.title)} name="title" value={notification.title} required onChange={handleInputChange} onBlur={handleInputChange} />
                {fieldTouch.title && !notification.title ? (
                    <span className="error">
                        <FormattedMessage id="TITLE_IS_REQUIRED" />
                    </span>
                ) : ''}
            </div>
            <div className="add-notification-label required">
                <label><FormattedMessage id="SHORT_TEXT" /></label>
                <textarea maxLength={255} className={getValidationation(fieldTouch.shortText, notification.shortText)} name="shortText" value={notification.shortText} onChange={handleInputChange} required rows={5} onBlur={handleInputChange} />
                {fieldTouch.shortText && !notification.shortText ? (
                    <span className="error">
                        <FormattedMessage id="SHORT_TEXT_IS_REQUIRED" />
                    </span>
                ) : ''}
            </div>
            <div className="add-notification-label">
                <label>url</label>
                <textarea maxLength={255} name="url" value={notification.url} required rows={5} onChange={handleInputChange} onBlur={handleInputChange} />
            </div>
            <div className="add-notification-button-group">
                <button
                    className="button-primary"
                    disabled={!isValidNofication(notification)}
                    type="button"
                    onClick={() => {

                        setFieldTouched({ shortText: true, language: true, title: true });
                        isEdit ? editNotificationItem(notification) : addNotification(notification);

                    }
                    }
                >
                    <FormattedMessage id="CONFIRM" />
                </button>
            </div>
        </section>
    );

};

AddNotification.propTypes = {
    item: PropTypes.object.isRequired,
    busyCounter: PropTypes.bool.isRequired,
    isEdit: PropTypes.bool.isRequired,
    editNotificationItem: PropTypes.func,
    addNotification: PropTypes.func,
};

export default AddNotification;
